/**
 * Ticket AD8: Hinweisseite, kein eigener Bereich. Keine Datenabfrage, keine
 * Schaltflächen – nur ein Wegweiser, damit der Menüpunkt nicht ins Leere zeigt.
 *
 * Entsteht hier der echte Bereich, muss die Kennzeichnung `muted: true` am
 * Eintrag „credentials" in src/lib/admin-nav.ts entfernt werden, sonst bleibt
 * eine funktionierende Seite dauerhaft zurückgenommen dargestellt.
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";

export const Route = createFileRoute("/_admin/admin/credentials")({
  component: AdminCredentialsPlaceholder,
});

function AdminCredentialsPlaceholder() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="Zugangsdaten-Übergaben"
        description="Künftig sind hier alle Übergaben und offenen Anforderungen über alle Kundinnen und Kunden hinweg an einer Stelle einzusehen."
      />
      <p className="max-w-2xl text-sm text-muted-foreground">
        Übergaben werden heute ausschließlich in der Kundenakte geführt: Öffnen Sie in der{" "}
        <Link to="/admin/clients" className="font-semibold underline">
          Kundenliste
        </Link>{" "}
        die gewünschte Kundin oder den gewünschten Kunden und wechseln Sie dort auf den Reiter
        „Zugangsdaten". Dort fordern Sie Zugänge an, sehen den Eingang und rufen ein hinterlegtes
        Geheimnis einmalig ab.
      </p>
    </div>
  );
}
